module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_12.5ffd9387.pdf";